import(/* webpackMode: "eager" */ "/home/coder/pubky-runtime/app-classic/src/app/(feeds)/layout.tsx");
